export const SESSION_CHECK_RETRY_INTERVAL_MS = 10_000

export const SESSION_UNAVAILABLE_TITLE = 'Сервер недоступен'
export const SESSION_UNAVAILABLE_DESCRIPTION = 'Не удалось проверить сессию. Данные не потеряны: повторите попытку через несколько секунд.'
export const SESSION_CHECK_RETRY_LABEL = 'Повторить'

export const SESSION_CHECK_ERROR_MESSAGES = {
  network: 'Нет соединения с сервером.',
  malformedResponse: 'Сервер вернул некорректный ответ на проверку сессии.',
  httpStatus: (status: number): string => `Сервер ответил ошибкой ${status}.`
} as const
